import { render, staticRenderFns } from "./MoveList.vue?vue&type=template&id=733ffc5e&scoped=true&"
import script from "./MoveList.vue?vue&type=script&lang=js&"
export * from "./MoveList.vue?vue&type=script&lang=js&"
import style0 from "./MoveList.vue?vue&type=style&index=0&id=733ffc5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ffc5e",
  null
  
)

export default component.exports